import { Component, forwardRef, Input, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'xpo-prime-dropdown',
  templateUrl: './xpo-prime-dropdown.component.html',
  styleUrls: ['./xpo-prime-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => XpoPrimeDropdownComponent),
      multi: true,
    },
  ],
})
export class XpoPrimeDropdownComponent implements ControlValueAccessor {
  @Input() source = [];
  @Input() formGroup: FormGroup;
  @Input() formControlName: string;
  @Input() formControlParentName: string;
  @Input() name: string;
  @Input() placeholder: string = '';
  @Input() filter: boolean = true;
  @Input() filterBy: string = '';
  @Input() showClear: boolean = true;
  @Input() required: boolean = false;
  @Input() optionLabel: string = 'id';
  @Input() optionLabelExtra: string = '';
  @Input() invertLabelExtra: boolean = false;
  @Input() editable: boolean = false;
  @Input() uppercaseOnEdit: boolean = false;
  @Input() optionValue: string = 'component';
  @Input() group: boolean = false;

  get control(): FormControl | null {
    if (!this.formGroup) {
      return null;
    }
    if (this.formControlParentName) {
      return this.formGroup.get(this.formControlParentName)?.get(this.formControlName) as FormControl;
    }
    return this.formGroup.get(this.formControlName) as FormControl;
  }

  isDisabled: boolean = false;

  private onChangeFn: (_: any) => void = () => {};
  private onTouchedFn: () => void = () => {};

  writeValue(value: any): void {}

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
